/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import DisbursalBT from "./DisbursalBT";
import DisbursalNew from "./DisbursalNew";
import DisbursalPostPledge from "./DisbursalPostPledge";
import DisbursalDisabled from "./DisbursalDisabled";
import DisbursalBTDisabled from "./DisbursalBTDisabled";
import DisbursalRePledge from "./DisbursalRePledge";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { repledgeCaseListName } from "assets/properties/properties";

const DisbursalDetails = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumber,
  loanApplicationNumbedisbusalDetails,
  setDisbursalLoan,
  status,
  closeModal,
  editable,
  customerProceedId,
  loanAccountNumber,
  subStatus,
  prePledgeLoan,
  prePledgeDisbursalDate,
  classes,
  loanType,
  initiatorType,
  seletedBranchCode,
  leadBranchCode,
  featureFlags,
  actualLoanAmount,
  prepledgeLoanMap,
  mobileNum,
  prepledgeLoanData
}) => {
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [applicantDetails,setApplicantDetails] = useState({}); 
  const [userDetails,setUserDetails] = useState({}); 
  const [yearlyCashValue, setYearlyCashValue]= useState("");
  const outletData = featureFlags;
  const financialYearCashValidationFlag = parseAndSetFlag(outletData?.financialYearCashValidationFlag);
  const checkForInterestAmountFlag = parseAndSetFlag(outletData?.checkForInterestAmountFlag);
  const cashAmountPerLoanDisbursalTime = outletData?.cashAmountPerLoanDisbursalTime;
  const enabledInsuranceFlowFlag = parseAndSetFlag(outletData?.enabledInsuranceFlowFlag);
    const [premiumDetails, setPremiumDetails] = useState({});
  useEffect(()=>{
    if(enabledInsuranceFlowFlag){
      GetPremium();
    }else{
      getApplicantDetails();
    }
  },[])
  const getApplicantDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data !== "" && Object.keys(result?.data)?.length > 0) {
      setApplicantDetails(result?.data);
      getUserDetails();
    }
  }
  const getUserDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    setCallInProgress(false);
    setUserDetails(result?.data);
      if (Number(cashAmountPerLoanDisbursalTime) > 0) {
        setYearlyCashValue(cashAmountPerLoanDisbursalTime);
        return;
      }
    if(financialYearCashValidationFlag){
      getCashDetails();
    }else{
      setYearlyCashValue(outletData?.cashThreshHoldFlag);
    }
  };
  const getCashDetails = async () =>{
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.GET_CASH_DETAILS_IN_YEAR + customerProceedId  + '?payInOrPayOut=PAYOUT',
          authToken: authToken,
        });
        setCallInProgress(false);
          if(result?.data?.error_code){
            setYearlyCashValue(0);
          }else{
            setYearlyCashValue(result?.data?.remainingBalance)
          }
  }
  const GetPremium = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.GET_INSURANCE_PREMIUM + loanApplicationId,
      authToken: authToken,
    });
    if (!res?.data?.error_code) {
      setPremiumDetails(res?.data);
    }
    await getApplicantDetails();
  };
  if (callInProgress) {
  return <CircularProgresss callInProgress={true} />;
}
  return (
    <>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {subStatus === "PRE_PLEDGE" ? (
        editable ? (
          <DisbursalBT
            classes={classes}
            status={status}
            loanApplicationId={loanApplicationId}
            loanApplicationNumber={loanApplicationNumber}
        loanApplicationNumbedisbusalDetails={
          loanApplicationNumbedisbusalDetails
        }
            closeModal={closeModal}
            setNext={setNext}
            setBack={setBack}
            setDisbursalLoan={setDisbursalLoan}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
            subStatus={subStatus}
            cashAmountPerLoanDisbursalTime={cashAmountPerLoanDisbursalTime}
             premiumDetails={premiumDetails}
          />
        ) : (
          <DisbursalBTDisabled
            loanApplicationId={loanApplicationId}
            setNext={setNext}
            setBack={setBack}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            closeModal={closeModal}
            status={status}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
            subStatus={subStatus}
             premiumDetails={premiumDetails}
          />
        )
      ) : subStatus === "POST_PLEDGE" ? (
        editable ? (
          <DisbursalRePledge
            classes={classes}
            status={status}
            loanApplicationId={loanApplicationId}
            loanApplicationNumber={loanApplicationNumber}
            loanApplicationNumbedisbusalDetails={loanApplicationNumbedisbusalDetails}
            closeModal={closeModal}
            setNext={setNext}
            setBack={setBack}
            setDisbursalLoan={setDisbursalLoan}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            prePledgeLoan={prePledgeLoan}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            removeMaturityvalidation={ subStatus === repledgeCaseListName?.renew && checkForInterestAmountFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
            subStatus={subStatus}
            cashAmountPerLoanDisbursalTime={cashAmountPerLoanDisbursalTime}
            premiumDetails={premiumDetails}
            actualLoanAmount={actualLoanAmount}
            prepledgeLoanMap={prepledgeLoanMap}
            prepledgeLoanData={prepledgeLoanData}
            prePledgeDisbursalDate={prePledgeDisbursalDate}
          />
        ) : (
          <DisbursalDisabled
            loanApplicationId={loanApplicationId}
            setNext={setNext}
            setBack={setBack}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            closeModal={closeModal}
            status={status}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
             premiumDetails={premiumDetails}
             actualLoanAmount={actualLoanAmount}
            prepledgeLoanMap={prepledgeLoanMap}
            prepledgeLoanData={prepledgeLoanData}
          />
        )
      ) : loanType === "RE_PLEDGE" ? (
        editable ? (
          <DisbursalRePledge
            classes={classes}
            status={status}
            loanApplicationId={loanApplicationId}
            loanApplicationNumber={loanApplicationNumber}
            loanApplicationNumbedisbusalDetails={loanApplicationNumbedisbusalDetails}
            closeModal={closeModal}
            setNext={setNext}
            setBack={setBack}
            setDisbursalLoan={setDisbursalLoan}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            prePledgeLoan={prePledgeLoan}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            removeMaturityvalidation={ subStatus === repledgeCaseListName?.renew && checkForInterestAmountFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
            subStatus={subStatus}
            cashAmountPerLoanDisbursalTime={cashAmountPerLoanDisbursalTime}
            premiumDetails={premiumDetails}
            actualLoanAmount={actualLoanAmount}
            prepledgeLoanMap={prepledgeLoanMap}
            prepledgeLoanData={prepledgeLoanData}
          />
        ) : (
          <DisbursalDisabled
            loanApplicationId={loanApplicationId}
            setNext={setNext}
            setBack={setBack}
            customerProceedId={customerProceedId}
            loanAccountNumber={loanAccountNumber}
            closeModal={closeModal}
            status={status}
            initiatorType={initiatorType}
            userDetails={userDetails}
            applicantDetails={applicantDetails}
            yearlyCashValue={yearlyCashValue}
            financialYearCashValidationFlag={financialYearCashValidationFlag}
            seletedBranchCode={seletedBranchCode}
            leadBranchCode={leadBranchCode}
            featureFlags={featureFlags}
             premiumDetails={premiumDetails}
          />
        )
      ) : editable ? (
        <DisbursalNew
          classes={classes}
          status={status}
          loanApplicationId={loanApplicationId}
          loanApplicationNumber={loanApplicationNumber}
          loanApplicationNumbedisbusalDetails={loanApplicationNumbedisbusalDetails}
          closeModal={closeModal}
          setNext={setNext}
          setBack={setBack}
          setDisbursalLoan={setDisbursalLoan}
          customerProceedId={customerProceedId}
          loanAccountNumber={loanAccountNumber}
          initiatorType={initiatorType}
          userDetails={userDetails}
          applicantDetails={applicantDetails}
          yearlyCashValue={yearlyCashValue}
          financialYearCashValidationFlag={financialYearCashValidationFlag}
          seletedBranchCode={seletedBranchCode}
          leadBranchCode={leadBranchCode}
          featureFlags={featureFlags}
          subStatus={subStatus}
          cashAmountPerLoanDisbursalTime={cashAmountPerLoanDisbursalTime}
           premiumDetails={premiumDetails}
        />
      ) : (
        <DisbursalDisabled
          loanApplicationId={loanApplicationId}
          setNext={setNext}
          setBack={setBack}
          customerProceedId={customerProceedId}
          loanAccountNumber={loanAccountNumber}
          closeModal={closeModal}
          status={status}
          initiatorType={initiatorType}
          userDetails={userDetails}
          applicantDetails={applicantDetails}
          yearlyCashValue={yearlyCashValue}
          financialYearCashValidationFlag={financialYearCashValidationFlag}
          seletedBranchCode={seletedBranchCode}
          leadBranchCode={leadBranchCode}
          featureFlags={featureFlags}
           premiumDetails={premiumDetails}
        />
      )}
    </>
  );
};

DisbursalDetails.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  closeModal: PropTypes.func,
  loanApplicationId: PropTypes.number,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.bool,
};

export default DisbursalDetails;
